<template>
    <div style="padding-bottom: 2px;">
    <svg width="23" height="25" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">        
        <path d="M10.9487 13.1099C4.80838 13.1099 0 15.6984 0 18.9989L1.22304 24H20.666L21.8639 19.2L21.889 18.9989C21.889 15.6984 17.0806 13.1099 10.9403 13.1099H10.9487ZM19.3592 22.3246H2.52984L1.67539 18.9068C1.79267 16.9382 5.5623 14.7853 10.9403 14.7853C16.3183 14.7853 20.0963 16.9382 20.2052 18.9068L19.3508 22.3246H19.3592Z" :fill="color"/>
        <path d="M10.948 12.0796C14.282 12.0796 16.9878 9.37382 16.9878 6.03979C16.9878 2.70576 14.2736 0 10.948 0C7.62234 0 4.9082 2.70576 4.9082 6.03979C4.9082 9.37382 7.61396 12.0796 10.948 12.0796ZM10.948 1.67539C13.3522 1.67539 15.3124 3.6356 15.3124 6.03979C15.3124 8.44398 13.3522 10.4042 10.948 10.4042C8.5438 10.4042 6.5836 8.44398 6.5836 6.03979C6.5836 3.6356 8.5438 1.67539 10.948 1.67539Z" :fill="color"/>            
    </svg>
    </div>
</template>

<script setup>
defineProps({
    color: {
        type: String,
        required: false,
        default: '#1C1C1C'
    }
});

</script>

